(function () {
  function fixMailtoLinks(root) {
    root.querySelectorAll('a[href^="mailto:"]').forEach((link) => {
      link.removeAttribute('target');
      link.removeAttribute('rel');
      link.removeAttribute('role');
    });
  }

  function initMailtoFix() {
    fixMailtoLinks(document);
  }

  document.addEventListener(
    'click',
    (event) => {
      if (event.defaultPrevented || event.button !== 0) return;

      const link = event.target.closest('a[href^="mailto:"]');
      if (!link) return;

      const href = link.getAttribute('href');
      if (!href) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.href = href;
    },
    true
  );

  initMailtoFix();
  document.addEventListener('DOMContentLoaded', initMailtoFix);

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(() => initMailtoFix()).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();
